import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { createContext, memo } from "react";

export interface UnifiedBillingSuiteStatuses {
  unifiedBillingEnabled: boolean;
}

export const UnifiedBillingSuiteStatusesContext = createContext<
  UnifiedBillingSuiteStatuses | undefined
>(undefined);

export const UnifiedBillingSuiteStatusesProvider = memo(
  function UnifiedBillingSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

    const billingSettingsLoad = useLoad(
      () => rpcClient.getAccountBillingSettings({}),
      [rpcClient],
    );

    const unifiedBillingSuiteStatuses: UnifiedBillingSuiteStatuses = {
      unifiedBillingEnabled:
        billingSettingsLoad.value?.unifiedBillingEnabled ?? false,
    };

    return (
      <UnifiedBillingSuiteStatusesContext.Provider
        value={unifiedBillingSuiteStatuses}
      >
        {children}
      </UnifiedBillingSuiteStatusesContext.Provider>
    );
  },
);
